import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { FreeBetWinningType, getAmountWithCurrency, toFixed, useTranslation } from '@pascal/pascal-core';
import { betStore, freeBetStore, gameConfigStore } from '@pascal/pascal-core/shared/core/store';

import { doBetStore, gameStore } from '../../../store';
import { globalTranslationKeys } from '../../../enums';

export const minOdd = 1.01;
const BetPlaceInfo = observer(() => {
  const {
    betInfoThisMoment: { odd, payout },
  } = doBetStore;
  const { repliedBetData } = betStore;
  const { minOddOverTaken } = gameStore;
  const { limits } = gameConfigStore;
  const { activeFreeBet } = freeBetStore;
  const t = useTranslation();

  const exactPayout = useMemo(() => {
    let correctPayout = payout;

    if (limits.maxWin < payout) {
      correctPayout = limits.maxWin;
    }

    if (activeFreeBet.id && activeFreeBet.winType === FreeBetWinningType.Win) {
      correctPayout -= activeFreeBet.amount;
      correctPayout = correctPayout > 0 ? correctPayout : 0;
    }

    return correctPayout ? toFixed(correctPayout) : 0;
  }, [payout, limits, activeFreeBet]);

  return (
    <div className='w-md-bet-info'>
      <div className={`w-md-bet-odd ${!repliedBetData && (minOddOverTaken || odd < minOdd) ? 'error' : ''}`}>
        <p>{t(globalTranslationKeys.Odd)}</p>
        <span style={odd ? {} : { visibility: 'hidden' }}>x{odd}</span>
      </div>
      <div className='w-md-bet-payout'>
        <p>{t(globalTranslationKeys.Payout)}</p>
        <span style={odd ? {} : { visibility: 'hidden' }}>
          {getAmountWithCurrency({ amount: exactPayout, withSpace: true })}
        </span>
      </div>
    </div>
  );
});

export default BetPlaceInfo;
